import { jsxs as u, jsx as x } from "react/jsx-runtime";
import { c as y } from "../index-rKuIKazb.js";
import b from "../LoadingElement/index.js";
import { useTheme as g } from "../ThemeProvider/index.js";
import '../assets/index16.css';const f = "_layout_mxe8c_2", p = "_secondary_mxe8c_31", z = "_emerald_mxe8c_38", h = "_danger_mxe8c_45", k = "_disabled_mxe8c_60", N = "_dark_mxe8c_67", e = {
  layout: f,
  "--size-mouse": "_--size-mouse_mxe8c_18",
  "--size-dog": "_--size-dog_mxe8c_22",
  secondary: p,
  emerald: z,
  danger: h,
  disabled: k,
  dark: N
}, E = (o) => {
  const {
    className: t,
    children: d,
    dataAaa: c,
    disabled: n,
    loading: m,
    onClick: r,
    secondary: l,
    size: a = "cat",
    theme: s = "default",
    type: _ = "button"
  } = o, i = g();
  return /* @__PURE__ */ u(
    "button",
    {
      className: y(
        e[i],
        e.layout,
        a && e[`--size-${a}`],
        s && e[s],
        l && e.secondary,
        n && e.disabled,
        t
      ),
      "data-aaa": c,
      onClick: r,
      type: _,
      children: [
        d,
        " ",
        m ? /* @__PURE__ */ x(b, {}) : null
      ]
    }
  );
};
export {
  E as default
};
